export const { getBusinessAlertsForAccount, getBusinessAlertReadData } = require('./businessAlertQueriesGraphQL');
